import * as constants from '../actions/constants';

function updateEntities(state, action) {
  const entities = state[action.resourceType];
  return {
    ...state,
    [action.resourceType]: entities.size ? entities.merge(action.entities) : action.entities,
  };
}

export default function entities(state = {}, action) {
  switch (action.type) {
    case (constants.UPDATE_ENTITIES): {
      return updateEntities(state, action);
    }
    case (constants.UPDATE_ENTITY_BATCH): {
      const { entities } = action;
      return entities.reduce((accum, action) => updateEntities(accum, action), state);
    }
    case (constants.ADD_ENTITY): {
      const { entity, resourceType } = action;
      return {
        ...state,
        [resourceType]: state[resourceType].set(entity.get('id'), entity),
      };
    }
    case (constants.REMOVE_ENTITY): {
      const { entityId, resourceType } = action;
      return {
        ...state,
        [resourceType]: state[resourceType].delete(entityId),
      };
    }
    case (constants.UPDATE_ENTITY): {
      const { entityId, entityType, entity } = action;
      return {
        ...state,
        [entityType]: state[entityType].set(entityId, entity),
      }
    }
    case (constants.DELETE_ENTITY): {
      const { entityId, entityType } = action;
      return {
        ...state,
        [entityType]: state[entityType].delete(entityId),
      }
    }
    default: {
      return state;
    }
  }
}
